import React from 'react';
import { connect } from 'react-redux';
import Auth from '../components/auth';
import actions from '../actions/index';
import LoadingIndicator from '../components/common/loading_indicator';
import appSelector from '../selectors/app_selector';
import Modal from '../components/modal';
import ErrorView from '../components/error';

const mapStateToProps = state => appSelector(state);

const mapDispatchToProps = dispatch => {
  return {
    handleMount: () => dispatch(actions.requestAuthentication()),
    handleSignIn: () => dispatch(actions.requestSignIn()),
    handleModalClose: () => dispatch(actions.showModal(false))
  };
};

export const AppContainer = React.createClass({

	componentDidMount: function() {
    this.props.handleMount();
  },

  render: function() {
    if(!this.props.hasErrors) {
      if(this.props.renderLoadingIndicator) {
        return <LoadingIndicator  />
      }
      if(this.props.renderAuthView) {
        return <Auth onClick={this.props.handleSignIn} />
      }
      else if(this.props.renderScheduleView) {
        return (
          <div className="abl-app-container">
            {this.props.children}
            <Modal onClose={this.props.handleModalClose} isOpen={this.props.modalIsOpen} />
          </div>
        );
      }
      else {
        return null;
      }
    }
    else {
      return (
        <ErrorView />
      );
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);


/** WEBPACK FOOTER **
 ** ./src/js/containers/app_container.js
 **/